import React, { useEffect } from 'react';
import { Card, Spin } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useQuery } from '@apollo/react-hooks';
import { queries } from '../../graphql/graphql';

const ViewPage = props => {
  const { match } = props;
  const { params } = match;
  const { loading, data = {}, refetch } = useQuery(queries.DIRECTORY, {
    variables: { id: params.id }
  });
  const { directory } = data;

  useEffect(() => {
    refetch();
  }, [data]);

  if (!loading && !directory) return <div>Directory not found.</div>;
  if (loading && !directory) return <Spin size="large" />;

  return (
    <>
      <Card hoverable style={{ minWidth: '350px', width: '50vw', padding: '20px' }}>
        <Card.Meta
          title={
            <div style={{ fontSize: '1em', fontWeight: 'bold' }}>
              Name: {directory.name}
              <br />
              Slug: {directory.slug}
            </div>
          }
          description={
            <>
              {directory.values &&
                directory.values.map(value => (
                  <p key={value.id}>
                    {value.name} - {value.description} - {value.directory}
                  </p>
                ))}
            </>
          }
        />
      </Card>
    </>
  );
};

const mapStateToProps = state => {
  return {
    loggedIn: state.auth.loggedIn
  };
};

ViewPage.propTypes = {
  loggedIn: PropTypes.bool.isRequired
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

const connectedViewPage = connect(mapStateToProps, mapDispatchToProps)(ViewPage);

export default connectedViewPage;
